import { Spinner as ClaySpinner } from '@bolteu/clay-react';

export interface SpinnerProps {
  size?: string;
}

const CLAY_SIZES = { '16px': 400, '24px': 500, '36px': 600, '48px': 700 } as const;

export function Spinner({ size = '24px' }: SpinnerProps) {
  const claySize = CLAY_SIZES[size as keyof typeof CLAY_SIZES];
  return (
    <ClaySpinner
      size={claySize ?? 'inherit'}
      style={claySize ? undefined : { width: size, height: size }}
      className="mx-auto text-inherit"
    />
  );
}
